"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventConstants = exports["default"] = /*#__PURE__*/_createClass(function EventConstants() {
  _classCallCheck(this, EventConstants);
});
_defineProperty(EventConstants, "QuestionAnswerComponent", Object.freeze({
  TRASH: 'trash',
  ANSWERED: 'answered',
  UNANSWERED: 'unanswered',
  ALL: 'all',
  PRIVATE: 'private',
  QUESTION_PROMPT: 'Type your question here',
  TAB_ONE_TEXT: 'Answered Questions',
  TAB_TWO_TEXT: 'My Questions'
}));
_defineProperty(EventConstants, "EventRegistrationTypeEnum", Object.freeze({
  SSO: 'SSO',
  REGISTRATION: 'REGISTRATION',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  TOKEN: 'TOKEN'
}));
_defineProperty(EventConstants, "AudienceAppType", Object.freeze({
  ME: 'Mobile Engagement',
  STANDARD: 'Standard'
}));
_defineProperty(EventConstants, "RegistrationLayoutEnum", Object.freeze({
  WIDE: 'WIDE',
  NARROW: 'NARROW'
}));
_defineProperty(EventConstants, "RegistrationColorDefaults", Object.freeze({
  HEADER_BACKGROUND_COLOR: '#FFFFFF',
  PAGE_BACKGROUND_COLOR: '#FFFFFF',
  DESCRIPTION_COLUMN_BACKGROUND_COLOR: '#FFFFFF',
  DESCRIPTION_COLUMN_FONT_COLOR: '#000000',
  REGISTRATION_COLUMN_BACKGROUND_COLOR: '#FFFFFF',
  REGISTRATION_COLUMN_FONT_COLOR: '#000000',
  REGISTRATION_COLUMN_BUTTON_COLOR: '#ff9800',
  REGISTRATION_COLUMN_BUTTON_FONT_COLOR: '#000000'
}));
_defineProperty(EventConstants, "QuestionTypeEnum", Object.freeze({
  SINGLE: {
    type: 'single',
    text: 'Single-Select'
  },
  MULTIPLE: {
    type: 'multiple',
    text: 'Multi-Select'
  }
}));
_defineProperty(EventConstants, "ScreenTypesEnum", Object.freeze({
  LOBBY: 'lobby',
  EXIT: 'exit',
  EVENT: 'event',
  TEAM_VIEW: 'teamView'
}));
_defineProperty(EventConstants, "ScreenNamesEnum", Object.freeze({
  LOBBY_NAME: {
    "default": 'Default Lobby Layout',
    standard: 'Untitled Lobby Layout'
  },
  EXIT_NAME: {
    "default": 'Default Exit Layout',
    standard: ''
  },
  EVENT_NAME: {
    "default": 'Default Event Layout',
    standard: 'Untitled Event Layout'
  },
  TEAM_VIEW_NAME: {
    "default": 'Default View',
    standard: 'Untitled View'
  }
}));
_defineProperty(EventConstants, "ControlRoomComponentsEnum", Object.freeze({
  POLLS: {
    name: 'Polls',
    type: 'polls',
    classScope: 'singleton'
  },
  AV: {
    name: 'Audio/Video',
    type: 'av',
    classScope: 'singleton'
  },
  QA: {
    name: 'Q & A',
    type: 'qa',
    classScope: 'singleton'
  },
  TEXT: {
    name: 'Text',
    type: 'text',
    classScope: 'multiple'
  },
  IMAGE: {
    name: 'Image',
    type: 'image',
    classScope: 'multiple'
  },
  SLIDESHOW: {
    name: 'Slideshow',
    type: 'slideshow',
    classScope: 'singleton'
  },
  SURVEYS: {
    name: 'Surveys',
    type: 'surveys',
    classScope: 'singleton'
  },
  IFRAME: {
    name: 'iFrame',
    type: 'iframe',
    classScope: 'multiple'
  },
  TIMER: {
    name: 'Timer',
    type: 'timer',
    classScope: 'singleton'
  },
  TELEPROMPTER: {
    name: 'Q&A Teleprompter',
    type: 'teleprompter',
    classScope: 'singleton'
  },
  VIDEO_PLAYER: {
    name: 'Video Player',
    type: 'video_player',
    classScope: 'singleton'
  },
  WEBCAM: {
    name: 'Webcam',
    type: 'webcam',
    classScope: 'singleton'
  },
  CHAT: {
    name: 'Chat',
    type: 'chat',
    classScope: 'singleton'
  }
}));
_defineProperty(EventConstants, "IframeUserDataValuesEnum", Object.freeze({
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  FIRST_NAME_LAST_NAME: 'First & Last Name',
  EMAIL: 'Email',
  COMPANY: 'Company',
  TRUE: 'true',
  FALSE: 'false',
  ZERO: '1',
  ONE: '0'
}));
_defineProperty(EventConstants, "EventStatusEnum", Object.freeze({
  CREATING: 'CREATING',
  COMPLETED: 'COMPLETED',
  STAGED: 'STAGED',
  ARCHIVED: 'ARCHIVED',
  SCHEDULED: 'SCHEDULED',
  RUNNING: 'RUNNING',
  calendarCompletedStatus: ['COMPLETED', 'STAGED'],
  completedEventStatuses: ['COMPLETED', 'STAGED', 'ARCHIVED'],
  afterCompletedStatuses: ['STAGED', 'ARCHIVED'],
  checkEventStarted: function checkEventStarted(status) {
    if (status === 'SCHEDULED') {
      return false;
    } else {
      return true;
    }
  },
  hasEventCompleted: function hasEventCompleted(status) {
    if (status === 'RUNNING' || status === 'SCHEDULED' || status === 'CREATING') {
      return false;
    } else {
      return true;
    }
  }
}));
/**
  * Event type..
*/
_defineProperty(EventConstants, "EventType", Object.freeze({
  LIVE: 'live',
  AUTOCAST: 'autocast',
  PRERECORDED: 'prerecorded'
}));
_defineProperty(EventConstants, "START_EVENT_DELAY", 15);